export const footerMobCss = `
.footer__links__warp details {
    border-bottom: solid 1px #e6e6e6;
    padding: 0 0 15px 0;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 120px;
    color: #000;
}

.footer__links__warp details {
    border-radius: 4px;
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.2);
    background-color: #fff;
    padding: 10px 16px;
    border-bottom: none;
    margin-bottom: 10px
}

.footer__links__warp details summary {
    outline: 0;
    border: none;
    position: relative;
    cursor: pointer;
    padding-right: 20px;
    color: #000;
    font-weight:var(--font-bold, 700)
}

.footer__links__warp ul li {
    margin-bottom: 10px;
}

.faq__ans {
    color: #747474
}

details summary::-webkit-details-marker {
    display: none
}
summary::after {
    border: solid #008cff;
    content: '';
    position: absolute;
    right: 0;
    top: 3px;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg)
}
`;
